let lang = document.documentElement.lang.slice(0, 2),
    language,
    appLanguage;

switch (lang) {
    case 'jp':
    case 'ja':
        language = 'ja';
        appLanguage = 'jp'
        break;
    case 'cn':
    case 'zh':
        language = 'zh';
        appLanguage = 'cn';
        break;
    default:
        language = appLanguage = 'en';
        break;
}

/**
 * @name LANGUAGE
 * @constant
 * @description Actual language code used inside the app
 */
export const LANGUAGE = language;

/**
 * @name APP_LANGUAGE
 * @constant
 * @description Language code used by end points
 */
export const APP_LANGUAGE = appLanguage;

/**
 * @name MS_EDGE
 * @constant
 * @description Determines if the current browser is Microsoft Edge
 */
export const MS_EDGE = (window.navigator.userAgent.indexOf("Edge") > -1);

/**
 * @name FIREFOX
 * @constant
 * @description Determines if the current browser is Firefox
 */
export const FIREFOX = navigator.userAgent.includes("Firefox");

/**
 * @name HOST
 * @constant
 * @description The base URL
 */
export const HOST = window.location.host === 'localhost:3000' ? document.querySelector('[data-local]').dataset.local : window.location.host;

/**
 * @name IE11
 * @constant
 * @description Determines if the current browser is Internet Explorer 11
 */
export const IE11 = (!!window.MSInputMethodContext && !!document.documentMode);

/**
 * @name CHROME
 * @constant
 * @description Determines if the current browser is Google Chrome
 */
export const CHROME = (window.navigator.userAgent.match('CriOS') || (window.chrome && window.chrome !== undefined && window.opr === undefined && !MS_EDGE && window.navigator.vendor === 'Google Inc.'))

/**
 * @name PROTOCOL
 * @constant
 * @description The protocol for the app
 */
export const PROTOCOL = 'https:';